import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Features from './pages/Features';
import Pricing from './pages/Pricing';
import CourseCreators from './pages/use-cases/CourseCreators';
import CorporateLearning from './pages/use-cases/CorporateLearning';
import Agencies from './pages/use-cases/Agencies';
import Blog from './pages/Blog';
import About from './pages/About';
import Contact from './pages/Contact';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="features" element={<Features />} />
          <Route path="pricing" element={<Pricing />} />
          <Route path="use-cases/course-creators" element={<CourseCreators />} />
          <Route path="use-cases/corporate-learning" element={<CorporateLearning />} />
          <Route path="use-cases/agencies" element={<Agencies />} />
          <Route path="blog" element={<Blog />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}

export default App;